import { useTranslation } from "react-i18next";
import { UserPlus, CreditCard } from "lucide-react";
import AuditCard from "./AuditCard";

export default function AuditResults({ data }) {
    const { t } = useTranslation();

    if (!data) return null;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <AuditCard
                title={t("admin.facebookAudit.signups")}
                icon={UserPlus}
                data={data.signups}
            />
            <AuditCard
                title={t("admin.facebookAudit.purchases")}
                icon={CreditCard}
                data={data.purchases}
            />
        </div>
    );
}
